import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class SubtypeEventModel extends BaseAPIModel {
    fields() {
        return {
            id_weez: { primaryKey: true, readOnly: true },
            name: {}
        };
    }

    // TODO: handle limit/offset rules
    static listUrl({ organization_id = null }) {
        if (organization_id) {
            return `/ticket/organizations/${organization_id}/settings/onboarding`;
        }
        return '/ticket/event/types';
    }
}
